<template>
  <div>
    <div class="page-header">
      <div class="page-leftheader">
        <div class="headline">
          <h4 class="page-title text-primary">Alle Modelle</h4>
        </div>
      </div>
      <div class="page-rightheader">
        <!--
          Hier stand @click="openEditModel(editModel, 'new')" — der Knopf reichte
          also den aktuellen Stand von editModel an die Funktion, die ihn als
          Erstes überschreibt. Der Parameter zeigte danach auf das ALTE Objekt
          des zuletzt bearbeiteten Modells; die Kategorie-Vorbelegung prüfte
          dessen Wert statt den des neuen, leeren Formulars. FOLGE: Wer erst ein
          Motorrad bearbeitete und danach „Modell hinzufügen" anklickte, bekam
          ein Formular ganz ohne Kategorie. Beim Anlegen wird kein Vorlagemodell
          gebraucht, deshalb null.
        -->
        <a
          class="btn btn-primary btn-pill mr-1"
          @click="openEditModel(null, 'new')"
          >Modell hinzufügen</a
        >
        <!--
          Hier stand ein Knopf „Mit Datenbank synchronisieren". Er ist
          entfernt, weil dahinter nichts mehr passieren kann: Die zugehörige
          Funktion syncWithExt() begann mit einem return und tat still gar
          nichts. Auch der Endpunkt POST /make/sync ist tot — er holt die Daten
          von einer fremden Schnittstelle (back4app), die laut Kommentar im
          ETSBackend nicht mehr antwortet
          (ETSBackend/controllers/v1/adminController.js:284: „Function is
          obscolete as the api call it used to do does not work anymore").
          Ein Klick hätte den Server in einen Fehler laufen lassen.
        -->
        <a
          class="btn btn-primary btn-pill mr-1"
          @click="$router.push('manufacturers')"
          >Automarken</a
        >
      </div>
    </div>
    <div>
      <div>
        <input
          v-model="search"
          type="search"
          class="form-control form-control-sm"
          placeholder="Suche..."
          aria-controls="example1"
        />
        <br />
      </div>
      <div class="card">
          <div class="table-responsive">
              <table class="table card-table table-vcenter text-nowrap">
                  <thead>
                      <th>Kategorie</th>
                      <th>Marke</th>
                      <th>Modell</th>
                      <th>Aktion</th>
                  </thead>
                  <tbody>
                    <tr v-for="model in models" :key="model._id">
                    <!--
                      Hier stand {{ model.category }} und damit der rohe Wert aus
                      der Sammlung: In der Spalte „Kategorie" stand englisch
                      „car" bzw. „bike". GET /make/model/all/:skip/:limit gibt
                      die Datensätze unverändert aus
                      (ETSBackend/controllers/v1/carManufacturerController.js,
                      allModelsWithLimit) — anders als /vehicleCategories, das
                      über toCategoryLabel vereinheitlicht. Die Übersetzung muss
                      deshalb hier passieren.
                    -->
                    <td class="align-middle">{{ categoryLabel(model.category) }}</td>
                    <td class="align-middle">{{ model.make }}</td>
                    <td class="align-middle">{{ model.model }}</td>
                    <td>
                      <a
                      title="Marke bearbeiten"
                      class="btn btn-primary btn-small mr-1"
                      @click="openEditModel(model, 'edit')"
                      ><i class="fas fa-edit"></i
                    ></a>
                    <a
                      title="Marke löschen"
                      class="btn btn-small btn-danger"
                      @click="openDeleteModel(model)"
                      ><i class="fas fa-trash-alt"></i
                    ></a>
                    </td>
                      </tr>
                  </tbody>
              </table>
          </div>

      </div>
      <div style="position:absolute; bottom: 500px;left:50%;height:40px;width:40px " v-intersect.quiet="infiniteScrolling"></div>
    </div>

    <!-- V-Dialoge -->
    <v-dialog 
        v-model="editDialog"
        width="500">
        <v-card>
         <v-card-title class="card">
            <h4 class="page-title text-primary" v-if="editModel.editType == 'edit'">Modell bearbeiten</h4>
            <h4 class="page-title text-primary" v-if="editModel.editType == 'new'">Modell hinzufügen</h4>
          </v-card-title>
          <v-card-text>
            <div class="form-group"> 
            <label class="form-label">Kategorie</label>
            <!--
              Die Auswahlwerte hießen „Car" und „Motorbike", im Bestand stehen
              aber ausschließlich „car" und „bike" (nachgezählt mit
              db.carmanufacturers.aggregate: 42 × car, 23 × bike, keine andere
              Schreibweise). v-model vergleicht Zeichen für Zeichen und fand
              deshalb nie einen passenden Eintrag — beim Bearbeiten blieb das
              Kategoriefeld leer. Wer dann trotzdem speicherte, schrieb eine
              dritte Schreibweise in die Sammlung. Gespeichert wird jetzt der
              Bestandswert, gelesen wird weiterhin die deutsche Beschriftung.
            -->
            <!--
              WAR FALSCH: Ein Datensatz OHNE Kategorie bekam beim Öffnen des
              Dialogs stillschweigend „Auto" vorausgewählt (normalizeCategory
              gab für alles Unbekannte CATEGORY_CAR zurück). Wer nur einen
              Schreibfehler im Modellnamen korrigierte, schickte damit
              ungefragt category='car' mit — der Server übernimmt das seit dem
              Fix in updateMakeAndModel auch wirklich, und ein Motorrad landete
              danach in der App unter „Autos". Betroffen wären 1256 von rund
              1320 Datensätzen, die heute gar keine Kategorie tragen.
              Deshalb gibt es für genau diesen Fall jetzt einen eigenen,
              ehrlichen Eintrag: Solange er ausgewählt bleibt, wird die
              Kategorie beim Speichern GAR NICHT mitgeschickt (siehe
              saveModelToServer), der Datensatz behält also seinen Zustand.
              Bei neuen Modellen und bei Datensätzen, die schon eine Kategorie
              haben, erscheint der Eintrag nicht.
            -->
            <select name="" id="" class="form-control" v-model="editModel.category">
              <option v-if="categoryWasUnset" :value="CATEGORY_UNSET">— nicht festgelegt —</option>
              <option :value="CATEGORY_CAR">Auto</option>
              <option :value="CATEGORY_MOTORBIKE">Motorrad</option>
            </select>
            <small class="text-muted" v-if="categoryWasUnset && editModel.category === CATEGORY_UNSET">
              Für dieses Modell ist keine Kategorie hinterlegt. Sie bleibt beim
              Speichern unverändert, solange hier nichts ausgewählt wird.
            </small>
          </div>
            <div class="form-group">
                <label class="form-label">Modell</label>
                <input type="text" class="form-control" placeholder="Modell..." v-model="editModel.model" v-bind:class="{'is-invalid': emptyValidation && (editModel.model == null || editModel.model == '')}">
            </div>
            <div class="form-group">
                <label class="form-label">Marke</label>
                <input type="text" class="form-control" placeholder="Marke..." v-model="editModel.make" v-bind:class="{'is-invalid': emptyValidation && (editModel.make == null || editModel.make == '')}">
                <!--
                  Der Kasten startet jetzt ausgeblendet. Vorher war er ohne
                  Angabe sichtbar und wurde erst durch hideAutoComplete()
                  versteckt — genau der Aufruf, der beim Öffnen des Dialogs auf
                  ein noch nicht vorhandenes Element traf. Beim ersten Öffnen
                  stand deshalb eine leere Karte unter dem Feld „Marke".
                -->
                <div class="card mb-0" id="autoComplete" style="visibility: hidden;">
                    <ul class="list-group p-0">
                      <li class="list-group-item autoCompleteList" v-for="el in autoCompleteResult" :key="el" @click="chooseAutoComplete(el)">{{el}}</li>
                    </ul>
                </div>
            </div>
          </v-card-text>
            <v-divider></v-divider>
        <v-card-actions>
            <v-spacer></v-spacer>
              <a class="btn btn-primary btn-pill mr-1" @click="editDialog=false">Abbrechen</a>
              <a class="btn btn-primary btn-pill" @click="saveModel()">Speichern</a>
          </v-card-actions>
        </v-card>
      </v-dialog>

    <v-dialog 
        v-model="deleteDialog"
        width="500">
        <v-card>
         <v-card-title class="card">
            <h4 class="page-title text-primary">Modell löschen</h4>
          </v-card-title>
          <v-card-text>
            Sind Sie sicher, dass Sie dieses Modell löschen wollen?
          </v-card-text>
                    <v-divider></v-divider>
        <v-card-actions>
            <v-spacer></v-spacer>
              <a class="btn btn-primary btn-pill mr-1" @click="deleteDialog=false">Abbrechen</a>
              <a class="btn btn-danger btn-pill" @click="deleteModel()">Löschen</a>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="emptyDialog" width="500">
      <v-card>
        <v-card-title class="card">
            <h4 class="page-title text-primary">Fehler</h4>
        </v-card-title>
        <v-spacer></v-spacer>
        <v-card-text>
          Zum Speichern müssen alle erforderlichen Felder ausgefüllt sein.
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
              <a class="btn btn-primary btn-pill" @click="emptyDialog=false">Okay</a>
          </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

// Kategoriewerte, wie sie in der Sammlung carmanufacturers wirklich stehen —
// geprüft mit db.carmanufacturers.distinct("category") (Ergebnis: ["bike",
// "car"]). Genau diese beiden Werte werden gespeichert; die Beschriftung im
// Dialog bleibt deutsch.
const CATEGORY_CAR = 'car';
const CATEGORY_MOTORBIKE = 'bike';

// Eigener Wert für „Datensatz hat gar keine Kategorie". Er wird NIE an den
// Server geschickt (saveModelToServer entfernt das Feld dann), sondern dient
// allein dazu, im Auswahlfeld ehrlich anzuzeigen, dass nichts hinterlegt ist —
// statt kommentarlos „Auto" vorzublenden.
const CATEGORY_UNSET = '';

// Weitere Schreibweisen, die das Backend derselben Fahrzeugart zuordnet
// (ETSBackend/controllers/v1/carManufacturerController.js, CAR_CATEGORY_NAMES
// und MOTORBIKE_CATEGORY_NAMES). Sie stehen zwar heute nicht in der Sammlung,
// die App schickt aber 'Car'/'Motorbike' — käme ein so angelegter Datensatz
// hier an, bliebe das Auswahlfeld sonst wieder leer.
const CAR_CATEGORY_NAMES = ['car', 'auto', 'pkw'];
const MOTORBIKE_CATEGORY_NAMES = ['bike', 'motorbike', 'motorcycle', 'motorrad'];

export default {
  components: {},

  data() {
    return {
      page: 0,
      totalPages: 1,
      ElementPerPage: 25,
      sort: null,
      order: true,

      history: false,
      
      search: "",

      models: [],
      // Anzahl der zuletzt geladenen Einträge. Stand vorher nirgends in
      // data() — deshalb fiel nicht auf, dass drei Stellen zwei verschiedene
      // Namen benutzten (lastCars und lastModels).
      lastModels: null,
      autoCompleteResult: [],
      editModel: '',

      // Die Auswahlwerte des Kategoriefeldes stehen als Konstanten oben. Sie
      // liegen hier zusätzlich in data(), weil die Vorlage nur auf Felder der
      // Komponente zugreifen kann — so kann der gespeicherte Wert nicht wieder
      // von der Prüfung im Programmcode abweichen.
      CATEGORY_CAR: CATEGORY_CAR,
      CATEGORY_MOTORBIKE: CATEGORY_MOTORBIKE,
      CATEGORY_UNSET: CATEGORY_UNSET,

      // Merkt sich, ob der GEÖFFNETE Datensatz beim Aufschlagen des Dialogs
      // schon eine Kategorie hatte. Nur wenn nicht, bietet das Auswahlfeld den
      // Eintrag „— nicht festgelegt —" an; und nur dann darf die Kategorie beim
      // Speichern weggelassen werden.
      categoryWasUnset: false,


      editDialog: false,
      deleteDialog: false,
      emptyDialog: false,
      emptyValidation: false,
      autoCompleteSilent: false,
    };
  },

  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    search: function () {
      if (this.search == "") {
        this.fetchModels();
      } else {
        this.page = 0;
        this.searchModels();
      }
    },
    editDialog: function () {
       if(this.editDialog == false) {
         this.emptyValidation = false;
         this.$forceUpdate();
       }
    },
    editModel: {
      handler() {
        // make konnte fehlen (editModel ist anfangs ein leerer Text, und aus
        // dem Server kommen Einträge ohne Marke) — .length lief dann auf
        // undefined und der Beobachter warf.
        const make = this.editModel != null ? this.editModel.make : null;
        if(!this.autoCompleteSilent && make != null && make.length > 0) {
          this.autoComplete();
        } else {
          this.hideAutoComplete();
        }
      },
      deep: true
    },
  },

  mounted() {
    this.fetchModels();
    
  },

  methods: {
    infiniteScrolling(entries, observer, isIntersecting) {
        if(isIntersecting){
            setTimeout(() => {
                var _this = this;
                // Geprüft wurde this.lastCars, geschrieben aber teils
                // lastModels (fetchModels) und teils lastCars (searchModels).
                // Nach dem ersten Laden blieb lastCars deshalb leer und nach
                // einer Suche stand hier ein Wert aus einer anderen Quelle —
                // das Nachladen war entweder blind oder dauerhaft tot. Jetzt
                // heißt das Feld an allen drei Stellen lastModels.
                if(this.lastModels == this.ElementPerPage || this.lastModels == null){
                  // Seitenzahl erst NACH einer erfolgreichen Antwort erhöhen.
                  //
                  // Vorher stand in beiden Zweigen this.page++ VOR der Anfrage.
                  // Scheiterte sie (Netzfehler, 401, 500), blieb die Zählung
                  // trotzdem stehen: Die betroffene Seite wurde nie geladen und
                  // beim nächsten Auslösen bei der übernächsten weitergemacht —
                  // 25 Modelle fehlten dauerhaft und waren nur durch Neuladen
                  // der Seite wiederzubekommen. Ein page-- im Fehlerzweig löst
                  // das nicht: Wer währenddessen tippt, setzt über den
                  // Beobachter des Suchfeldes page auf 0, und daraus würde -1.
                  // Gleiches Muster wie in Manufacturers.vue.
                  const nextPage = this.page + 1;
                  const skip = nextPage * this.ElementPerPage;

                  const appendModels = function (response) {
                    // WAR FALSCH: Eine Ablehnung (HTTP 200, success:false) sah
                    // bisher genauso aus wie "die Liste ist zu Ende" — data
                    // fehlt dann, .length griff auf undefined zu und warf; der
                    // Fehler landete im .catch, das Nachladen blieb stumm.
                    if (response.data != null && response.data.success === false) {
                      _this.lastModels = 0;
                      _this.onError(response.data);
                      return;
                    }
                    _this.lastModels = response.data.data.length;
                    if(response.data.data.length >= 1) {
                      _this.page = nextPage;
                      response.data.data.forEach(item => _this.models.push(item));
                    }
                  };

                  if(this.search ==  "" || this.search == null){
                    this.$axios
                          .get('/make/model/all/' + skip + '/' + this.ElementPerPage)
                          .then(appendModels)
                          .catch(_this.onError);
                  }
                  else{
                    // Ohne encodeURIComponent zerlegte ein „/" oder „?" im
                    // Suchbegriff die Adresse und die Anfrage landete auf
                    // einer anderen Route.
                    // Der führende Schrägstrich fehlte hier als einziger Stelle
                    // in der Datei — axios setzt ihn zwar selbst ein, die
                    // abweichende Schreibweise verdeckte den Vergleich mit den
                    // übrigen Aufrufen aber unnötig.
                    this.$axios
                          .get('/make/model/search/' + encodeURIComponent(this.search) + '/' + skip + '/' + this.ElementPerPage)
                          .then(appendModels)
                          .catch(_this.onError);
                  }
                }
            }, 500);
        }
    },
    // WAR FALSCH: Der Fehlerbehandler schrieb nur in die Entwicklerkonsole,
    // die niemand offen hat. Ein fehlgeschlagener Abruf oder eine abgelehnte
    // Änderung (Ändern/Löschen) sah dadurch aus wie "es passiert nichts" —
    // der Dialog schloss sich (bzw. blieb offen, siehe saveModelToServer),
    // aber niemand erfuhr, warum. Zwei Formen kommen vor: Axios-Fehler
    // (Netz/HTTP, err.response gesetzt) und der Antwortkörper eines
    // fachlichen Fehlschlags ({success:false, message:"…"} mit HTTP 200), den
    // die Aufrufer unten direkt hereinreichen. Gleiches Muster wie in
    // Users.vue/Reported.vue.
    onError(err) {
      if (err != null && err.response != null && err.response.data != null) {
        console.error(err.response.data);
      } else {
        console.error(err);
      }
      const status = err != null && err.response != null ? err.response.status : null;
      // Bei 401/403 bleibt es bei der zentralen Meldung aus main.js — eine
      // zweite Meldung hier würde diese sofort wieder verdecken (Noty läuft
      // mit killer: true).
      if (status === 401 || status === 403) return;
      let message = null;
      if (err != null && err.response != null && err.response.data != null && err.response.data.message) {
        message = err.response.data.message;
      } else if (err != null && err.response == null && err.success === false && err.message) {
        message = err.message;
      }
      this.$noty.error(message || 'Die Anfrage ist fehlgeschlagen.');
    },
    fetchModels() {
      var _this = this;
      // page wurde hier nicht zurückgesetzt: Nach dem Scrollen und
      // anschließendem Leeren der Suche zeigte die Liste wieder die ersten 25
      // Einträge, das Nachladen sprang aber bei der alten, hohen Seitenzahl
      // weiter — die Einträge dazwischen fehlten dauerhaft.
      this.page = 0;
      this.$axios
        .get("/make/model/all/0/" + this.ElementPerPage)
        .then(function (response) {
          // WAR FALSCH: response.data.data wurde ungeprüft in models
          // geschrieben. Lehnte der Server ab (HTTP 200, success:false),
          // fehlt data — die Tabelle zeigte "undefined" in jeder Zeile statt
          // der Modellliste, ohne jede Meldung. Jetzt bleibt bei einer
          // Ablehnung die zuletzt geladene Liste stehen, die Servermeldung
          // erscheint als Hinweis.
          if (response.data == null || response.data.success === false) {
            _this.onError(response.data);
            return;
          }
          _this.models = response.data.data;
          _this.lastModels = response.data.data.length;
        })
        .catch(_this.onError);
    },
    // Nach Speichern und Löschen muss die Liste so neu geladen werden, wie sie
    // gerade angezeigt wird. Das feste fetchModels() holte dagegen immer die
    // ungefilterte Liste, obwohl der Suchbegriff noch im Feld stand: Die
    // Tabelle sprang ohne erkennbaren Grund auf alle Modelle zurück, und beim
    // Weiterscrollen hängte das Nachladen dann Suchtreffer an die vollständige
    // Liste — dieselbe _id kam zweimal vor, worauf Vue Zeilen falsch
    // wiederverwendet. Gleiche Lösung wie in UserAutos.vue.
    reloadModels() {
      if (this.search == null || this.search === "") {
        this.fetchModels();
      } else {
        this.page = 0;
        this.searchModels();
      }
    },
    // Erkennt, ob in einem Datensatz überhaupt eine Kategorie steht, die einer
    // der beiden Fahrzeugarten entspricht. Nötig, um „hat keine Kategorie" von
    // „ist ein Auto" unterscheiden zu können — vorher fielen beide Fälle in
    // normalizeCategory zusammen.
    hasKnownCategory(category) {
      const value = String(category == null ? '' : category).trim().toLowerCase();
      return MOTORBIKE_CATEGORY_NAMES.indexOf(value) >= 0 || CAR_CATEGORY_NAMES.indexOf(value) >= 0;
    },
    // Führt einen Kategoriewert auf einen der beiden Auswahlwerte zurück.
    //
    // WAR FALSCH: Der Rückfall am Ende lautete „return CATEGORY_CAR" und galt
    // damit auch für einen LEEREN Wert. Beim Öffnen eines Datensatzes ohne
    // Kategorie stand deshalb kommentarlos „Auto" im Auswahlfeld und wurde beim
    // Speichern mitgeschickt. Jetzt gibt die Funktion für Unbekanntes und
    // Leeres CATEGORY_UNSET zurück; wer eine Vorbelegung braucht (neues
    // Modell), setzt sie ausdrücklich — siehe initializeModel und
    // openEditModel.
    normalizeCategory(category) {
      const value = String(category == null ? '' : category).trim().toLowerCase();
      if (MOTORBIKE_CATEGORY_NAMES.indexOf(value) >= 0) return CATEGORY_MOTORBIKE;
      if (CAR_CATEGORY_NAMES.indexOf(value) >= 0) return CATEGORY_CAR;
      return CATEGORY_UNSET;
    },
    // Deutsche Beschriftung für die Tabelle. Ein unbekannter Wert wird
    // unverändert durchgereicht, statt stillschweigend zu „Auto" zu werden —
    // sonst sähe ein von Hand angelegter Datensatz richtig aus, obwohl er in
    // der App unter der falschen Fahrzeugart auftaucht.
    categoryLabel(category) {
      const value = String(category == null ? '' : category).trim().toLowerCase();
      if (MOTORBIKE_CATEGORY_NAMES.indexOf(value) >= 0) return 'Motorrad';
      if (CAR_CATEGORY_NAMES.indexOf(value) >= 0) return 'Auto';
      return category;
    },
    openEditModel(model, type) {
        this.autoCompleteSilent = true;
        this.initializeModel();
        if(type == 'edit') {
            // Kopie statt Verweis: Hier stand this.editModel = model, editModel
            // zeigte damit direkt auf das Objekt aus der Tabellenzeile. Die
            // Eingabefelder schrieben beim Tippen sofort in die angezeigte
            // Liste — die Zeile änderte sich mit, „Abbrechen" nahm nichts
            // zurück, und nach einem fehlgeschlagenen Speichern stand in der
            // Tabelle ein Wert, den die Datenbank nie gesehen hat. Gleiche
            // Lösung wie in UserAutos.vue (openEditModel).
            this.editModel = Object.assign({}, model);
        }
        this.editModel.editType = type;
        // Die Kategorie wird auf einen der beiden Auswahlwerte gebracht — aber
        // nur, wenn im Datensatz auch wirklich eine steht. Vorher wurde nur bei
        // fehlender Kategorie vorbelegt und dazu der ÜBERGEBENE Datensatz
        // geprüft statt der eigene Stand — beim Anlegen zeigte der Parameter
        // auf das zuletzt bearbeitete Modell (siehe Kommentar am Knopf), sodass
        // das Feld leer blieb.
        //
        // WAR FALSCH: Danach lief jeder Datensatz OHNE Kategorie durch
        // normalizeCategory und kam als „Auto" heraus. Beim Speichern einer
        // reinen Namenskorrektur wurde dieses „Auto" mitgeschickt und vom
        // Server übernommen — ein Motorrad landete in der App unter den Autos,
        // ohne dass der Verwalter das entschieden hätte. Jetzt merkt sich
        // categoryWasUnset diesen Fall, das Auswahlfeld zeigt dafür
        // „— nicht festgelegt —", und saveModelToServer lässt die Kategorie in
        // der Anfrage weg, solange sie nicht ausdrücklich gewählt wurde.
        this.categoryWasUnset = (type === 'edit') && !this.hasKnownCategory(this.editModel.category);
        // Der Rückfall auf CATEGORY_CAR greift nur beim ANLEGEN: Dort bietet
        // das Auswahlfeld den Eintrag „— nicht festgelegt —" bewusst nicht an,
        // ein leerer Wert würde also ein leeres Feld zeigen.
        this.editModel.category = this.categoryWasUnset
            ? CATEGORY_UNSET
            : (this.normalizeCategory(this.editModel.category) || CATEGORY_CAR);
        this.editDialog = true;
        Vue.nextTick(() => {
          this.autoCompleteSilent = false;
        });
    },
    saveModel() {
      let _this = this;
      this.emptyValidation = true;
      this.$forceUpdate();


      Vue.nextTick(() => {
        if(document.getElementsByClassName('is-invalid').length > 0) {
          this.emptyDialog = true;
          return;
        }
        _this.saveModelToServer();
      });
    },
    saveModelToServer() {
      let _this = this;
      const modelToSave = Object.assign({}, this.editModel);
      // WAR FALSCH: `id` wurde immer gesetzt — auch beim ANLEGEN, wo `_id` der
      // leere Vorbelegungswert '' ist (siehe openNewModelDialog). Mongoose
      // bildet ein mitgeschicktes `id` auf `_id` ab und versucht daraus eine
      // Datenbankkennung zu machen; aus '' wird dabei ein Umwandlungsfehler und
      // der Server antwortet mit HTTP 500. Der Verwalter sah nur, dass der
      // Knopf „Speichern" nichts bewirkt — ohne jeden Hinweis, denn der
      // .catch()-Zweig schreibt bis heute nur in die Entwicklerkonsole.
      // Beim Bearbeiten ist `_id` gefüllt und wird weiterhin gebraucht.
      if (modelToSave._id) {
        modelToSave.id = modelToSave._id;
      }
      delete modelToSave.editType;
      delete modelToSave._id;
      delete modelToSave.updatedAt;
      delete modelToSave.createdAt;

      // WAR FALSCH: Die Kategorie ging IMMER mit — auch dann, wenn der
      // Datensatz gar keine hatte und das Auswahlfeld nur die stillschweigende
      // Vorbelegung „Auto" zeigte. Der Server übernimmt einen mitgeschickten
      // Wert (ETSBackend/controllers/v1/carManufacturerController.js,
      // updateMakeAndModel), also wurde aus „unbekannt" ungefragt „Auto".
      // Steht das Feld weiterhin auf „— nicht festgelegt —", wird es jetzt aus
      // der Anfrage entfernt; der Datensatz behält damit genau den Zustand, den
      // er hatte.
      if (modelToSave.category === CATEGORY_UNSET) {
        delete modelToSave.category;
      }

      if(this.editModel.editType == 'new') {
        delete modelToSave.modelId;
        // POST /make verlangt requireAuth und admin (ETSBackend/routes/V1.js:362).
        // Das Dashboard erfüllt beides: Angemeldet wird über /signInDashboard,
        // das seinerseits hinter admin liegt (routes/V1.js:422), und der
        // Abfangjäger in main.js hängt den Token an jede Anfrage.
        this.$axios.post('/make', modelToSave).then(function (response) {
          // WAR FALSCH: Der Erfolgszweig schloss den Dialog und lud die
          // Liste neu, ohne response.data.success zu prüfen. Lehnt der
          // Server ab (z. B. Marke/Modell existiert bereits, HTTP 200 mit
          // success:false), schloss sich der Dialog trotzdem — der
          // Verwalter hielt das Anlegen für geglückt, es wurde aber nichts
          // gespeichert.
          if (response.data != null && response.data.success === false) {
            _this.onError(response.data);
            return;
          }
          _this.editDialog = false;
          // Hier stand fetchModels() — siehe Kommentar bei reloadModels.
          _this.reloadModels();
        }).catch(_this.onError)
      } else {
        // WAR FALSCH (überholter Hinweis, hier gestanden): „PUT /make übernimmt
        // serverseitig nur make und model, eine geänderte Kategorie wird nicht
        // gespeichert." Das stimmte einmal, gilt aber seit der Korrektur in
        // ETSBackend/controllers/v1/carManufacturerController.js
        // (updateMakeAndModel) nicht mehr — und es widersprach dem Kommentar
        // wenige Zeilen weiter oben, der genau umgekehrt begründet, warum die
        // Kategorie bei „nicht festgelegt" aus der Anfrage entfernt wird. Zwei
        // gegensätzliche Aussagen in derselben Funktion sind schlimmer als
        // keine: Wer den falschen zuerst liest, hält den Schutz oben für
        // überflüssig und baut ihn aus.
        //
        // Heutiger Stand, im Servercode nachgelesen: PUT /make übernimmt make,
        // model UND category — Letztere aber nur, wenn das Feld auch wirklich
        // im Rumpf steht (Prüfung auf undefined/null/leer). Ein weggelassenes
        // Feld löscht die vorhandene Kategorie also nicht.
        this.$axios.put('/make', modelToSave).then(function (response) {
          // Gleiche Absicherung wie beim Anlegen oben: Ohne sie schloss sich
          // der Dialog auch bei einer Ablehnung, als sei alles gespeichert.
          if (response.data != null && response.data.success === false) {
            _this.onError(response.data);
            return;
          }
          _this.editDialog = false;
          _this.reloadModels();
        }).catch(_this.onError)
      }

    },
    openDeleteModel(model) {
      this.editModel = model;
      this.deleteDialog = true;
    },
    deleteModel() {
      let _this = this;
      // Route: DELETE /make/:id (ETSBackend/routes/V1.js:364) — genau ein
      // Parameter, dazu requireAuth und admin. Der Admin-Token kommt aus
      // main.js, siehe Kommentar in saveModelToServer.
      this.$axios
        .delete('/make/' + this.editModel._id)
        .then(function (response) {
          // WAR FALSCH: Der Erfolgszweig schloss den Dialog und lud die
          // Liste neu, ohne zu prüfen, ob der Server das Löschen überhaupt
          // zugelassen hat (z. B. bei einem nicht mehr vorhandenen
          // Datensatz, HTTP 200 mit success:false). Der Eintrag stand danach
          // unverändert weiter in der Tabelle, der Dialog verschwand aber so,
          // als sei alles erledigt.
          if (response.data != null && response.data.success === false) {
            _this.onError(response.data);
            return;
          }
          _this.deleteDialog = false;
          // Hier stand fetchModels() — siehe Kommentar bei reloadModels.
          _this.reloadModels();
        })
        .catch(_this.onError);
    },
    searchModels() {
      var _this = this;
      this.$axios
        .get(
          // Ohne encodeURIComponent zerlegte ein „/" oder „?" im Suchbegriff
          // die Adresse und die Anfrage landete auf einer anderen Route.
          "/make/model/search/" +
            encodeURIComponent(this.search) +
            "/" +
            this.page +
            "/" +
            this.ElementPerPage
        )
        .then(function (response) {
          // Gleiche Absicherung wie in fetchModels: Ohne sie überschrieb eine
          // Ablehnung die Liste mit undefined statt sie unverändert zu lassen.
          if (response.data == null || response.data.success === false) {
            _this.onError(response.data);
            return;
          }
          _this.models = response.data.data;
          // Hieß hier lastCars, in fetchModels aber lastModels — siehe
          // Kommentar beim Nachladen. Jetzt überall lastModels.
          _this.lastModels = _this.models.length;
        })
        .catch(_this.onError);
    },
    initializeModel() {
        this.editModel = {
            make: '',
            model: '',
            // category fehlte hier. Vue 2 macht nur die Felder beobachtbar, die
            // beim Zuweisen des Objekts schon vorhanden sind — ein danach
            // angelegtes category war es nicht, sodass das Auswahlfeld beim
            // Anlegen nicht zuverlässig mitzog.
            category: CATEGORY_CAR,
            _id: '',
            editType: '',
        }
    },
    autoComplete() {
      let _this = this;

      if(this.editModel.make.length > 0) {
        // Ohne encodeURIComponent zerlegte ein „/" oder „?" in der Eingabe die
        // Adresse — bei einer Vorschlagsliste, die bei jedem Tastendruck
        // anfragt, passiert das schnell.
        this.$axios.get('/make/search/' + encodeURIComponent(this.editModel.make) + '/0/5').then(function (response) {
          // Eine Ablehnung lieferte bisher kein data — der Zugriff auf
          // .length warf, die Vorschlagsliste blieb dadurch stumm hängen.
          // Bewusst ohne $noty.error: Das läuft bei jedem Tastendruck, eine
          // Meldung pro Buchstabe wäre störender als der Vorschlagskasten,
          // der einfach leer bleibt.
          if (response.data == null || response.data.success === false) {
            _this.autoCompleteResult = [];
            _this.setAutoCompleteVisibility(false);
            return;
          }
          _this.autoCompleteResult = response.data.data;
          // Der Kasten wurde bisher auch bei null Treffern eingeblendet — bei
          // jedem Tippfehler stand eine leere Karte unter dem Feld „Marke".
          _this.setAutoCompleteVisibility(response.data.data.length > 0);
        }).catch(function () {
          // Netzfehler bei der Vorschlagsliste: gleiche Zurückhaltung, keine
          // Meldung pro Tastendruck — der Kasten bleibt einfach zu.
          _this.setAutoCompleteVisibility(false);
        });
      } else {
        this.hideAutoComplete();
      }
    },
    hideAutoComplete() {
      this.setAutoCompleteVisibility(false);
    },
    // Der Kasten mit den Vorschlägen steckt im Dialog und existiert erst,
    // wenn dieser aufgebaut ist. Der editModel-Beobachter läuft aber schon
    // beim Öffnen (initializeModel setzt make auf '') — getElementById lieferte
    // dann null und setAttribute warf, noch bevor der Dialog zu sehen war.
    setAutoCompleteVisibility(visible) {
      const element = document.getElementById('autoComplete');
      if (element == null) return;
      element.setAttribute('style', visible ? 'visibility: visible;' : 'visibility: hidden;');
    },
   chooseAutoComplete(el) {
     this.autoCompleteSilent = true;
     this.editModel.make = el;
     // Der Kasten wurde bisher nur nebenbei versteckt, nämlich über den
     // editModel-Beobachter. Stimmt der angeklickte Vorschlag mit dem bereits
     // getippten Text überein („BMW" tippen, „BMW" anklicken), meldet Vue
     // keine Änderung, der Beobachter läuft nicht und die Vorschlagsliste
     // blieb offen stehen. Jetzt wird sie direkt geschlossen.
     this.hideAutoComplete();
     Vue.nextTick(() => {
       this.autoCompleteSilent = false;
     });
   },
  },
};


</script>

<style scoped>
.v-dialog > .v-card > .v-card__actions {
  padding: 8px 16px;
}
</style>